import { methodGet, methodDelete, methodPost, methodPut } from './methods';
import { API_INFO } from '../constants';

export async function getAllFaqs(payload) {
  const url = API_INFO + 'company/faqs/';
  return methodGet(url, payload);
}

export async function getFaq(id) {
  const url = API_INFO + `company/faqs/${id}/`;
  return methodGet(url);
}

export async function createFaq(payload) {
  const url = API_INFO + 'company/faqs/';
  return methodPost(url, payload);
}

export async function deleteFaq(id) {
  const url = API_INFO + `company/faqs/${id}/`;
  return methodDelete(url, {});
}

export const editFaq = async (payload, id) => {
  const url = API_INFO + `company/faqs/${id}/`;
  return methodPut(url, payload);
}

export async function reorderFaq(payload) {
  const url = API_INFO + `company/faqs/reorder/`;
  return methodPost(url, payload);
}
